function ProductReducer(state = {
    productBugList: [], selectBugModalStatus: '', storageList: [], productMainGroupList: [],
    productGroupList: [], productTypeList: [], productHolderList: [], costCenterList: [],
    productGroupSelectList: [], productListFull: [], product: null, attachmentList:[]
}, action) {
    switch (action.type) {
        case "SEARCH_PRODUCT_BUG":
            return {
                ...state,
                productBugList: action.data
            }
        case "SET_PBUG_POP":
            return {
                ...state,
                selectBugModalStatus: action.data
            }
        case "FETCH_STORAGE_LIST":
            return {
                ...state,
                storageList: action.data
            }
        case "GET_PRODUCT_MAIN_GROUPS":
            return {
                ...state,
                productMainGroupList: action.data
            }
        case "GET_PRODUCT_GROUPS":
            return {
                ...state,
                productGroupList: action.data
            }
        case "GET_PRODUCT_TYPES":
            return {
                ...state,
                productTypeList: action.data
            }
        case "GET_PRODUCT_HOLDERS":
            return {
                ...state,
                productHolderList: action.data
            }
        case "GET_COSTCENTER_LIST":
            return {
                ...state,
                costCenterList: action.data
            }
        case "GET_PRODUCTGROUP_For_SELECT":
            return {
                ...state,
                productGroupSelectList: action.data
            }
        case "SEARCH_PRODUCTS_Full":
            return {
                ...state,
                productListFull: action.data
            }
        case "GET_PRODUCT": {
            return {
                ...state,
                product: action.data
            }
        }
        case "GET_PRODUCT_ATTACHMENTS": {
            return {
                ...state,
                attachmentList: action.data
            }
        }
        default:
            return state;
    }
}
export default ProductReducer;